export default "__VITE_ASSET__DQFX$QPP__"